import React from 'react'
import { StyleSheet, View } from 'react-native'

interface HorizontalLineProps {
  color?: string
}

export default function ({ color = '#000' }: HorizontalLineProps) {
  return <View style={{ ...styles.line, borderBottomColor: color }} />
}

const styles = StyleSheet.create({
  line: {
    alignSelf: 'stretch',
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
})
